import * as React from 'react';

import { useAuth } from '../contexts/auth/useAuth';
import { Root } from '../Root';
import { ResponseInterceptor } from '../api/ResponseInterceptor';

/**
 * Wraps Root with the 401 response interceptor. Rendering is gated on
 * isAuthenticated so we don't hit the backend before Keycloak has set the
 * access token. Unauthenticated users are auto-redirected to Keycloak by the
 * Auth provider's `onLoad: 'login-required'`, so we don't need a fallback
 * route here — render nothing while we wait.
 */
const ProtectedRoute = () => {
  const auth = useAuth();

  if (!auth.isAuthenticated) {
    return null;
  }

  return (
    <>
      <ResponseInterceptor/>
      <Root/>
    </>
  );
}

export { ProtectedRoute }
